'use strict';

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {};
import mutations from './mutations';
import actions from './actions';
import getters from './getters';


// modles
import core 		from './core';
import orm  		from './orm';

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
    	core,
    	orm,
    },
});



// WEBPACK FOOTER //
// ./src/store/index.js